import { render } from "./NavCard.vue?vue&type=template&id=49897498"
import script from "./NavCard.vue?vue&type=script&lang=js"
export * from "./NavCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__